import { t } from '@/i18n';
import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.application_season.breadcrumb.seasons_label1'),
    link: '/application',
  },
  {
    label: t('pages.application_season.breadcrumb.seasons_label2'),
    link: '/application/championships',
  },
  {
    label: t('pages.application_season.breadcrumb.seasons_label3'),
    link: '/application/championships/seasons',
  },
  {
    label: t('pages.application_season.breadcrumb.seasons_label4'),
  },
];
